import styled from "styled-components";
import {AppHeaderCrossBrandTextDefaultBox} from "./app-header-cross-brand-text.default.box";

export const AppHeaderCrossBrandTextMrgreenBox = styled(AppHeaderCrossBrandTextDefaultBox)`
  display: inline-block;
`;
